import { ConnectDragPreview, ConnectDragSource, DragSourceMonitor, useDrag } from 'react-dnd';
import { useDispatch } from 'react-redux';
import { ARTBOARD_CELL_ACCEPTED_DROP_TYPE } from 'components/ArtboardCell/useArtboardCellDropTarget';
import { EntityType } from 'const';
import { toggleDragState } from 'containers/App/actions';
import { AssetDragObject, GroupLayoutDocumentMap, ReusableLayoutMap } from 'models';

type Props = {
  component: ReusableLayoutMap | GroupLayoutDocumentMap;
};

type DragSourceHook = {
  isDragging: boolean;
  dragRef: ConnectDragSource;
  preview: ConnectDragPreview;
};

export const useLayoutListItemRenditionDragSource = ({ component }: Props): DragSourceHook => {
  const dispatch = useDispatch();
  const dragSourceType = ARTBOARD_CELL_ACCEPTED_DROP_TYPE;
  const componentType = EntityType.LAYOUT_RENDITION;
  const [{ isDragging }, dragRef, preview] = useDrag<AssetDragObject, void, { isDragging: boolean }>({
    type: dragSourceType,
    item: () => {
      dispatch(toggleDragState(dragSourceType, componentType));

      return {
        type: componentType,
        component,
      };
    },
    end: () => {
      dispatch(toggleDragState());
    },
    collect: (monitor: DragSourceMonitor) => ({
      isDragging: monitor.isDragging(),
    }),
  });

  return {
    isDragging,
    dragRef,
    preview,
  };
};
